import assetPath from '/app/xinglets/upsell/campaign-page/src/assets/visa.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')